var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v("\n\t"+_vm._s("Copyright © 版权所有，并保留所有权利")+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }